import React from 'react';
import './Map.css';

class Map extends React.Component {
  render() {
    return (
      <section className="map" id="map">
        <iframe
         src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2577.9682077586526!2d18.64078031586644!3d49.74904197938466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471403f6749b260d%3A0x874d799188f6e53d!2sBielska%2037%2C%2043-400%20Cieszyn!5e0!3m2!1spl!2spl!4v1570353362207!5m2!1spl!2spl" 
         title="podolog-mapa-dojazdu"
         width="100%" 
         height="400px" 
         frameBorder="0">
         </iframe>
      </section>
    );
  }
}

export default Map;
